import { Modal } from "react-bootstrap";

import "./summaryInfo.css";

export default function SummaryInfo({
  test, hidePopup,
}: any) {
  if (test) {
    return (
      <>
        <Modal
          show={test}
          onHide={() => {
            hidePopup();
          }}
          backdrop="static"
          dialogClassName="reflectInfo-200w"
          size="sm"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
          backdropClassName="backdrop2"
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                color: "#495057",
                fontSize: "15px",
                fontWeight: "600",
              }}
            >
              iProcedures ProcID
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-0 ms-2">
            <p className="msgClass">The ProcID is iProcedures' internal case identifier.  In the iPro Lite mobile app or the Epic linked web app, open the case and scroll to the bottom to find this number.  In the iPro Core app, find it at the bottom of the first screen of Patient Info.</p>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <button
              className="buttonCss"
              onClick={() => {
                hidePopup();
              }}
            >
              <i className="pi pi-check me-1"></i>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
}
